module.exports = __webpack_public_path__ + "images/style-6-4c89dd8e7ccf947415559af565aa3233.jpg";